import { http, HttpResponse } from 'msw';
import { DEMO_PORTFOLIO_SUMMARY, DEMO_EQUITY_CURVE, DEMO_POSITIONS } from '../demo-fixtures';

const BASE = import.meta.env?.VITE_API_BASE_URL ?? 'http://localhost:8000';

export const demoPortfolioHandlers = [
  // ── Portfolio summary ─────────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/portfolio/summary`, () => {
    return HttpResponse.json(DEMO_PORTFOLIO_SUMMARY);
  }),

  // ── Portfolio equity curve (cross-bot aggregated) ─────────────────────────
  http.get(`${BASE}/api/v1/portfolio/equity-curve`, () => {
    const now = new Date();
    const ninetyDaysAgo = new Date(now);
    ninetyDaysAgo.setDate(ninetyDaysAgo.getDate() - 89);
    return HttpResponse.json({
      from: ninetyDaysAgo.toISOString(),
      to: now.toISOString(),
      interval: '1d',
      data: DEMO_EQUITY_CURVE,
    });
  }),

  // ── Cross-bot positions ───────────────────────────────────────────────────
  http.get(`${BASE}/api/v1/positions`, () => {
    return HttpResponse.json({
      items: DEMO_POSITIONS,
      total: DEMO_POSITIONS.length,
      limit: 50,
      offset: 0,
    });
  }),

  // ── Cross-bot orders ──────────────────────────────────────────────────────
  // (Note: also handled in orders.ts — whichever is registered last wins in MSW)
];
